import { getProjectRouter } from "@project/router";
import { initializeProjectTenant } from "@project/services";
import { RouterProvider } from "@tanstack/react-router";
import { useEffect } from "react";

const projectRouter = getProjectRouter();

export default function ProjectApp() {
  // Theme tokens live on .jivandhara-site; Radix dialogs/selects portal to <body>,
  // so attach the class on <html> so portaled UI gets solid backgrounds & colors.
  useEffect(() => {
    initializeProjectTenant();
    document.documentElement.classList.add("jivandhara-site");
    return () => document.documentElement.classList.remove("jivandhara-site");
  }, []);

  return (
    <div className="jivandhara-site min-h-screen">
      <RouterProvider router={projectRouter} />
    </div>
  );
}
